export default __webpack_public_path__ + "static/media/staffProfile.599b91f6.svg";